import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap/modal";
import { PreisEintrag } from "../../Api/DcoApi/Admin/AdminClasses";
import { RestClient } from "../../Api/DcoApi/Client/RestClient";
import { AdminCard } from "../Controlls/Sonstige/AdminCard";
import { DateSelect } from "../../Akte/Controlls/DateSelect";

@Component({
  selector: 'PriceEdit',
  standalone: true,
  imports: [CommonModule, FormsModule, AdminCard, DateSelect],
  templateUrl: './PriceEdit.html',
  styleUrl: './PriceEdit.css'
})

export class PriceEdit  {
  @Input() header: string = '';
  @Input() url: string = '';
  @Input() labelText: string = '';
  @Input() CurrentPrice: number = 0;

  PriceEntry: PreisEintrag | null = null;
  Client: RestClient = new RestClient();
  get Item(): PreisEintrag {
    if (this.PriceEntry == null)
      this.PriceEntry = { preis: this.CurrentPrice, preisBis: new Date() } as PreisEintrag

    return this.PriceEntry;

  }

  async Send() {
    if (this.PriceEntry != null) {
      this.Client.Post<PreisEintrag, PreisEintrag>(this.url, this.PriceEntry).then(r => { this.modal.close(this.PriceEntry) });
    }
         
  }

  modal = inject(NgbActiveModal);
}
